import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import styles from './SelectDialog.scss';
import ScrollableDialog from 'components/controls/dialogs/ScrollableDialog';
import Scrollbars from 'react-custom-scrollbars';
import BaseItemsList from 'components/controls/BaseItemsList';
import Button from 'components/controls/Button';
import TextField from 'components/controls/TextField';
import SelectUsersListItem from 'components/controls/SelectUsersDialog/SelectUsersListItem';

import {alwaysTruePredicate} from 'components/helpers/funcTools';

export default class SelectUsersDialog extends PureComponent {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    usersList: PropTypes.object,
    usersListPart: PropTypes.object,
    usersListProcessing: PropTypes.bool,
    usersListError: PropTypes.object,
    onSelectUser: PropTypes.func.isRequired,
    onGetUsers: PropTypes.func.isRequired,
    entityId: PropTypes.string,
    label: PropTypes.string,
    title: PropTypes.string,
    okLabel: PropTypes.string,
    role: PropTypes.string,
    itemsFilter: PropTypes.func,
  }

  static defaultProps = {
    entityId: null,
    label: loc('select-doctor-for-attach'),
    title: loc('select-doctor'),
    okButtonLabel: loc('attach-label'),
    role: null,
    itemsFilter: alwaysTruePredicate,
  };

  state = {
    selected: null,
    search: '',
  };

  handleRenderUser = (user, key) => {
    const {itemsFilter} = this.props;

    if (!itemsFilter(user)) {
      return;
    }
    const {selected} = this.state;

    return (
      <SelectUsersListItem
        key={key}
        user={user}
        selected={selected}
        onSelect={this.setSelected}
      />
    );
  }

  setSelected = id => {
    this.setState({selected: id});
  }

  handleAttach = () => {
    const {onSelectUser, entityId} = this.props;
    const {selected} = this.state;

    onSelectUser(entityId, selected);
  }

  handleChangeSearch = ({target: {value}}) => {
    this.setState({search: value, selected: null});
  }

  render() {
    const {
      onClose,
      title,
      label,
      entityId,
      okButtonLabel,
      onGetUsers,
      role,
      usersList,
      usersListPart,
      usersListProcessing
    } = this.props;
    const {search, selected} = this.state;
    const scrollbarsId = 'UsersScrollbars';

    return (
      <ScrollableDialog
        onClose={onClose}
        title={title}
        containerClassName={styles.container}
        contentClassName={styles.dialog}
        scrollBarConfig={{
          autoHeight: true,
          autoHeightMin: 0,
          autoHeightMax: 800
        }}
      >
        <div className={styles.label}>{label}</div>
        <TextField
          onChange={this.handleChangeSearch}
          value={search}
          placeholder={loc('enter-doctor-or-vma')}
          className={styles.searchField}
        />
        <Scrollbars
          id={scrollbarsId}
          autoHeight
          autoHeightMin={'20rem'}
          autoHeightMax={'20rem'}
          className={styles.scroll}
        >
          <BaseItemsList
            list={usersList}
            listPart={usersListPart}
            listProcessing={usersListProcessing}
            scrollbarsId={this.refs.scrollbars}
            onRenderItem={this.handleRenderUser}
            onGetItems={onGetUsers}
            placeholderClassName={styles.placeholder}
            params={{
              entityId: typeof entityId === 'string' ? entityId : undefined,
              filter: {
                search,
              },
              role,
            }}
          />
        </Scrollbars>
        <div className={styles.actions}>
          <Button label={okButtonLabel} onClick={this.handleAttach} disabled={!selected} />
          <Button type='cancel' onClick={onClose} label={loc('cancel-label')} />
        </div>
      </ScrollableDialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/controls/SelectUsersDialog/SelectUsersDialog.jsx